
import { mapState, mapActions, mapMutations } from 'vuex'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import questionIcon from 'assets/icons/icon-customer-service@3x.png'
import iconKefu from 'assets/icons/icon_kefu1@3x.png'
import isValid from '../../utils/validor'
import editIcon from 'assets/icons/icon_pen_edit@3x.png'
import meiqia from '../../utils/meiqia'

export default {
name: 'SportsTourPackageConfirm',
components: {
XHeader,
XNumber,
XInput,
Datetime,
Group,
Checker,
CheckerItem,
XButton,
XTextarea,
},
data() {
return {
questionIcon,
iconKefu,
editIcon,
initTourOrderData: {
tourId: 0,
personCount: 1,
contactInfo: {
id: '',
name: null,
mobile: null,
},
},


minCount: 1,
}
},
computed: {
...mapState({
sportsTourRoute: ({ sportsTour }) => sportsTour.sportsTourRoute,
attn: ({ attn }) => attn.commonAttn,
tourOrderData: ({ order }) => order.tourOrderData,
}),
targetCities() {
if (this.sportsTourRoute && this.sportsTourRoute.targetCitys) {
const cityNames = this.sportsTourRoute.targetCitys.map(city => city.name)
return cityNames.join(' ')
}
return ''
},
expectPay() {
const totalPay = this.sportsTourRoute.totalPrice * this.tourOrderData.personCount
return totalPay / 100
},
advancePay() {
const totalPay = this.sportsTourRoute.totalPrice * this.tourOrderData.personCount
return (totalPay * this.sportsTourRoute.advancePayRate) / 10000
},
hasAttn() {
if (this.tourOrderData.contactInfo.id) {
return true
}
if (this.attn.id) {
this.tourOrderData.contactInfo = this.attn
return true
}
return false
},
},
methods: {
...mapMutations({
saveTourOrderData: 'SAVE_TOUR_ORDER_DATA',
}),

...mapActions(['fetchUserCommonAttnByUserId', 'fetchSportsTourRouteById', 'fetchBasicConfig', 'showToast']),
mutateOrder() {
const { routeId } = this.$route.params
const self = this
self.tourOrderData.tourId = routeId
self.saveTourOrderData(self.tourOrderData)
},
goToAttn(type, attnId) {
const query = { from: 'tourOrder' }
if (attnId) {
query.id = attnId
} else {
query.type = 'attn'
}
this.mutateOrder()
this.$router.push({
name: `attn-${type}`,
query,
})
},
formateDate(timestamp) {
const date = new Date(timestamp)
const year = date.getFullYear()
const month = date.getMonth() + 1
const day = date.getDate()
return `${year}-${month}-${day}`
},
submitOrder() {
const self = this
const { routeId } = this.$route.params
const { userId } = this.$jwt
const { name, mobile } = this.tourOrderData.contactInfo

if (!name) {
this.showToast({
content: '请输入联系人姓名',
})
return false
}

if (isValid('number', name)) {
this.showToast({
content: '联系人填写有误，请检查！',
size: '15em',
})
return false
}

if (!mobile) {
this.showToast({
content: '请输入联系人手机号码',
size: '15em',
})
return false
}

if (!isValid('mobile', mobile)) {
this.showToast({
content: '手机号码填写有误，请输入11位国内手机号码！',
size: '21em',
})
return false
}

const req = {
personCount: self.tourOrderData.personCount,
contactInfo: {
name,
mobile,
},
packageTourRouteId: +routeId,
userId,
}

return this.$http.post('/api/tourOrder', req).then(res => res.json()).then((data) => {
self.$router.push({
name: 'travel-order-pay',
query: {
orderId: data.id,
type: 'tour',
},
})
})
.catch((err) => {
self.showToast({
content: err.body.resultInfo,
})
})
},
chat() {
meiqia.showPanel()
},
},
mounted() {
document.body.scrollTop = 0
},
created() {
document.title = '确认预订'
meiqia.init(null, meiqia.travelGroupToken)
const { routeId } = this.$route.params

this.fetchUserCommonAttnByUserId(this.$jwt.userId)
this.fetchSportsTourRouteById({
routeId,
}).then(() => {
if (+routeId !== +this.tourOrderData.tourId) {
this.saveTourOrderData(this.initTourOrderData)
}
})
},
}



// WEBPACK FOOTER //
// ./client/components/SportsTour/SportsTourPackageConfirm.vue